// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".techcast-english .timeline[data-v-3f9ea091]{padding-top:5.75rem;padding-bottom:8rem;padding-left:var(--site-padding);padding-right:var(--site-padding);display:grid;grid-template-columns:1fr}.techcast-english h2[data-v-3f9ea091]{justify-self:center;margin-bottom:3.5rem}@media(min-width:815px){.techcast-english .timeline[data-v-3f9ea091]{padding-left:0;padding-right:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
